import type { FunctionComponent } from 'react';

import { usePropertyPageModalContext } from '../../../../contexts/PropertyPageModalContext/PropertyPageModalContext';
import { Button } from '@property.com.au/ui-kit';
import { useTrackBeforeYouBuyModalEvent } from '../../../../hooks/useTrackBeforeYouBuyModalEvent';
import type { CtaButtonProps } from '../../HeaderCtas';

export const BeforeYouBuyCta: FunctionComponent<{ cta: CtaButtonProps }> = ({ cta }) => {
  const { displayModal } = usePropertyPageModalContext();
  const trackBeforeYouBuyModalEvent = useTrackBeforeYouBuyModalEvent();

  const handleClick = () => {
    displayModal({ name: 'beforeYouBuyModal' });
    trackBeforeYouBuyModalEvent('property_page__byb_header_button');
  };

  return (
    <Button
      key={cta.text}
      onClick={handleClick}
      icon={cta.icon}
      iconPlacement={cta.iconPlacement}
      sizeVariant={cta.sizeVariant}
      variant={cta.variant}
    >
      {cta.text}
    </Button>
  );
};
